import {Client} from "@/util/api";
import {HasLocationCodeInterface} from "@/types/HasLocationCode";
import {ValidationRule} from "vee-validate/dist/types/types";
import {Currency} from "@/enums/Currency";
import {DiscountCheckInterface} from "@/types/DiscountCheck";
import {Member} from "@/util/Member";

export const locationCodeRuleCreator = (api: Client, eventId: number, errorCallback?: (error:Error) => any): ValidationRule => ({
  async validate(value) {
    if (!value) {
      return false
    }
    try {
      const hasLocationCodeResponse = await api.post<HasLocationCodeInterface>(`/events/${eventId}/hasLocationCode`, {inputValue: value}, undefined, false);
      return hasLocationCodeResponse.valid
    } catch (e) {
      if(errorCallback) {
        errorCallback(e);
      }

      return false;
    }
  }
});

export const callbackRuleCreator = (validationCallback: (value:string) => boolean): ValidationRule => ({
  async validate(value) {
    return validationCallback(value);
  }
});

export const discountRuleCreator = (api: Client, member: Member, currency: Currency, index: number, errorCallback?: (error:Error) => any, successCallback?: (response:DiscountCheckInterface) => void): ValidationRule => ({
  async validate(value) {
    if (!value) {
      member.discount = undefined;
      return true
    }
    try {
      const discountCheckResponse = await api.post<DiscountCheckInterface>(`/discount/check`, {discount: value, ticketCategoryId: member.ticketCategoryId, memberId: member.id, email: member.email, currency, index }, undefined, false);

      if(successCallback){
        successCallback(discountCheckResponse);
      }

      return discountCheckResponse.isAllowed;

    } catch (e) {
      if(errorCallback) {
        errorCallback(e);
      }

      return false;
    }
  }
});


